export const ui = {
  noDataMessage: 'მონაცემები არ არის',
  unknownName: '(უცნობი სახელი)',
  loading: 'იტვირთება',
  image: {
    dropFileHere: 'ჩააგდეთ ფაილი აქ',
    uploadFile: 'დააწკაპუნეთ ან გადმოიტანეთ',
    imageRestrictions: 'ატვირთეთ .jpeg ან .png, მაქს. ზომა: 5 MB.',
    wrongFileFormat: 'არასწორი ფაილის ფორმატი',
    tooLargeSize: 'ფაილის ზომა ძალიან დიდია',
    noname: '(სურათის სახელი არ არის)',
    mobile: {
      uploadFile: 'ატვირთვის\u00a0თვის დააწკაპუნეთ',
    },
    crop: {
      title: 'ავატარის მორგება',
      description: 'ატვირთვამდე გადააადგილეთ და გადიდეთ სურათი.',
      modalTitle: 'ავატარის მორგება',
      modalDescription: 'ატვირთვამდე მოარგეთ სურათის ზონა და მასშტაბი.',
      zoom: 'მასშტაბი',
      cancel: 'გაუქმება',
      confirm: 'დადასტურება',
      processing: 'მუშავდება...',
    },
  },
};
